// src/Students.tsx
import React, { useEffect, useState } from "react";
// import Dashboard from './Dashboard';
import Dashboard from "../dashboard/Dashboard";
// import "./students.scss"; // Import the SCSS file
import "./teachers-table.scss";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../utils/constants";

interface ITeacher {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  teachingType: string;
}

interface ITeacherData {
  isLoading: boolean;
  teachers: ITeacher[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function TeachersTable() {
  const query = useQuery();
  const status = query.get("status");

  const [totalTeachers, setTotalTeachers] = useState<number>(0);
  const [TeachersData, setTeachersData] = useState<ITeacherData>({
    isLoading: true,
    teachers: [],
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterYear, setFilterYear] = useState<string>("");

  useEffect(() => {
    if (status) {
      fetchTeachersByStatus(status);
    }
  }, [status]);

  const fetchTeachersByStatus = async (status: string) => {
    fetch(`${API_URL}/teachers/list?status=${status}`)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setTeachersData({
          isLoading: false,
          teachers: data.result,
        });
        // console.log(data.result)
      })
      .catch((err) => {
        console.log("Error fetching teachers:", err);
      });
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setFilterYear(event.target.value);
    setCurrentPage(1); // Reset to the first page when a new filter is applied
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Dashboard pageTitle="Teachers">
      <div className="students-page">
        {/* Search and Filter */}
        <div className="search-filter">
          <input
            type="text"
            placeholder="Search by student name"
            value={searchTerm}
            onChange={handleSearch}
          />
          <select onChange={handleFilterChange} value={filterYear}>
            <option value="">Filter by enrollment year</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
          </select>
        </div>

        {/* Students Table */}
        <div className="students-table">
          {/* <h3>Teachers List (First 25)</h3> */}
          {TeachersData.isLoading ? (
            <p>Loading...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  {/* <th>ID</th> */}
                  <th>Fullname</th>
                  <th>Email</th>
                  <th>Teaching Type</th>
                </tr>
              </thead>
              <tbody>
                {TeachersData.teachers.map((teacher) => (
                  <tr
                    key={teacher.id}
                    onClick={() =>
                      (window.location.href = `/teachers/${teacher.id}/details?status=${status}`)
                    }
                  >
                    <td>
                      {teacher.first_name} {teacher.last_name}
                    </td>
                    <td>{teacher.email}</td>
                    <td>{teacher.teachingType} </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Dashboard>
  );
}
